module.exports = __webpack_public_path__ + "img/mind_skeleton_18.13f1daca.png";